export const isSizeFilter = (field, value) => {
  return (
    field === 'variant_mfield_utopia_size_label' ||
    field === 'filter.v.option.size' ||
    field === 'size' ||
    field.toLowerCase().includes('size') ||
    value?.includes(',')
  )
}

export const formatUniversalSizeValue = (value) => {
  if (!value?.includes(',')) {
    return value
  }

  const preferredSizeRange = localStorage.getItem('preferred_size_range') || 'US'
  const sizesByGender = parseSizeString(value)

  if (!sizesByGender) {
    return value
  }

  const sizeValues = []

  Object.entries(sizesByGender).forEach(([, sizesByType]) => {
    if (sizesByType[preferredSizeRange]) {
      const displaySize = sizesByType[preferredSizeRange]
      sizeValues.push(displaySize)
    }
  })

  if (sizeValues.length > 0) {
    const sizeTypeLabel = preferredSizeRange === 'EU' ? 'EU' : preferredSizeRange
    return `${sizeTypeLabel} ${sizeValues[0]}`
  }

  return value
}

export const parseSizeString = (sizeString) => {
  const sizingArray = sizeString.split(',')

  const sizesByGender = {}
  let euroSize = null

  sizingArray.forEach(val => {
    const cleanVal = val.trim()

    if (cleanVal.includes('WOMENS') || cleanVal.includes('MENS') || cleanVal.includes('KIDS')) {
      const parts = cleanVal.split(' ')
      if (parts.length >= 3) {
        const gender = parts[0]
        const sizeType = parts[1]
        const sizeValue = parseFloat(parts[2])

        if (!isNaN(sizeValue) && sizeValue > 0) {
          if (!sizesByGender[gender]) {
            sizesByGender[gender] = {}
          }
          sizesByGender[gender][sizeType] = sizeValue
        }
      }
    } else if (cleanVal.startsWith('EURO ')) {
      const parts = cleanVal.split(' ')
      if (parts.length >= 2) {
        const sizeValue = parseFloat(parts[1])
        if (!isNaN(sizeValue) && sizeValue > 0) {
          euroSize = sizeValue
        }
      }
    }
  })

  if (euroSize && Object.keys(sizesByGender).length > 0) {
    Object.keys(sizesByGender).forEach(gender => {
      sizesByGender[gender].EU = euroSize
    })
  }

  return Object.keys(sizesByGender).length > 0 ? sizesByGender : null
}

export const getAvailableGenders = (universalSizes) => {
  return Object.keys(universalSizes).sort()
}

export const getAvailableSizeTypes = (universalSizes) => {
  const sizeTypes = new Set()
  Object.values(universalSizes).forEach(genderSizes => {
    Object.keys(genderSizes).forEach(sizeType => {
      sizeTypes.add(sizeType)
    })
  })
  return Array.from(sizeTypes).sort()
}
